import qs from 'qs';

export default function parseLocationSearch(search) {

    return qs.parse(search ? search.substr(1) : location.search.substr(1))
}
